module.exports = __webpack_public_path__ + "static/media/ticketone-mobile.17f7fef9.svg";